/* eslint-disable import/prefer-default-export */
import * as React from 'react'

import Login from '../pages/Login'
import Home from '../pages/Home'
import SolarPlantList from '../pages/SolarPlantList'
import Settings from '../pages/Settings'
import AddnewPlant from '../pages/AddNewPlant'
import AddMacID from '../pages/AddMacid'
import PlantTechnicalView from '../pages/PlantTechicalView'
import BusinessView from '../pages/PlantBusinessView'
import PlantMapView from '../pages/PlantMapView'
import SolarMapView from '../pages/SolarMapView'
import LogReport from '../pages/LogReport'
import UserList from '../pages/UserListing'
import InternalUserList from '../pages/InternalUserlist'
import MonthlyGeneration from '../pages/MonthlyGenerationDownload'
import IssueManagement from '../pages/IssueManagement'
import BillingRecords from '../pages/BillingRecords'
import DailyGenerationReport from '../pages/DailyGenerationReport'
import InvoiceRecords from '../pages/InvoiceRecords'
import Homeimg from '../assets/images/home_3.svg'
import SolarPlant from '../assets/images/solar plant_3.svg'
import Settingsicon from '../assets/images/settings.svg'
import InvoiceBillDownload from '../pages/InvoiceBillDownload/InvoiceBillDownload'
import PlantReport from '../pages/PlantReport/PlantReport'
import NotificationView from '../pages/NotificationView/NotificationView'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment'
import AnalyticsIcon from '@mui/icons-material/Analytics';
import FeedIcon from '@mui/icons-material/FeedOutlined';


export const ROUTES = {
  LOGIN: {
    path: '/',
    key: 'login',
    name: 'Login',
    exact: true,
    isSecured: false,
    hasMainNav: false,
    hasSideNav: false,
    listInSideNav: false,
    hasTopNav: false,
    UserType: true,
    Component: Login,
    params: {},
  },
  DASHBOARD: {
    path: '/dashboard',
    key: 'dashboard',
    name: 'Home Page',
    exact: true,
    redirectPath: '/dashboard',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: false,
    Component: Home,
    sideNavIcon: <img src={Homeimg} alt="home icon" />,
    params: {},
  },
  SOLARPLANTLIST: {
    path: '/solarplantlist',
    key: 'solarplantlist',
    name: 'Solar Plant List',
    exact: true,
    redirectPath: '/solarplantlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: SolarPlantList,
    sideNavIcon: <img src={SolarPlant} alt="solarplant icon" />,
    permissions: ['entity.all', 'plant.read'],
    params: {},
  },
  ADDNEWPLANT: {
    path: '/addnewplant',
    key: 'addnewplant',
    name: 'Add Plant',
    exact: true,
    redirectPath: '/addnewplant',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: AddnewPlant,
    permissions: ['plant.create'],
    sideNavIcon: <img src={SolarPlant} alt="add plant icon" />,
    params: {},
  },
  ISSUEMANAGEMENT: {
    path: '/issue-management',
    key: 'issuemanagement',
    name: 'Issue Management',
    exact: true,
    redirectPath: '/issue-management',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: IssueManagement,
    sideNavIcon: <AssignmentIcon sx={{ color: '#5e68a3ff' }} />,
    permissions: ['issue.all', 'issue.read', 'issue.create', 'issue.update', 'issue.delete'],
    params: {},
  },
  DAILYGENRATIONREPORT: {
    path: '/daily-generation-report',
    key: 'dailygenerationreport',
    name: 'DGR',
    exact: true,
    redirectPath: '/daily-generation-report',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: DailyGenerationReport,
    sideNavIcon: <AnalyticsIcon sx={{ color: '#5e68a3ff' }} />,
    permissions: ['daily_generation_report.all', 'daily_generation_report.read', 'daily_generation_report.create', 'daily_generation_report.update', 'daily_generation_report.delete'],
    params: {},
  },
  BILLINGRECORDS: {
    path: '/billing-records',
    key: 'billingrecords',
    name: 'Billing Records',
    exact: true,
    redirectPath: '/billing-records',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: BillingRecords,
    sideNavIcon: <ReceiptLongIcon sx={{ color: '#5e68a3ff' }} />,
    permissions: ['invoice.all', 'invoice.read', 'invoice.download'],
    params: {},
  }, INVOICERECORDS: {
    path: '/invoice-records',
    key: 'invoice-records',
    name: 'Invoice Records',
    exact: true,
    redirectPath: '/invoice-records',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: false,
    Component: InvoiceRecords,
    sideNavIcon: <FeedIcon sx={{ color: '#5e68a3ff' }} />,
    permissions: ['invoice.all', 'invoice.read', 'invoice.create', 'invoice.update', 'invoice.zoho', 'invoice.email', 'invoice.download'],
    params: {},
  },
  REPORTS: {
    path: '/settings',
    key: 'settings',
    name: 'Settings',
    exact: true,
    redirectPath: '/settings',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: Settings,
    sideNavIcon: <img src={Settingsicon} alt="Settings icon" />,
    permissions: [
      'settings.all',
      'user.all', 'settings.listOfUsers', 'user.read', 'user.create',
      'settings.organizations.read', 'organization.all',
      'settings.roles.read', 'role.read',
      'settings.entities.read',
      'settings.reports',
      'settings.changePassword',
      'settings.emailSettings'
    ],
    params: {},
  },
  ADDdeviceId: {
    path: '/Devicelist',
    key: 'Devicelist',
    name: 'Devicelist',
    exact: true,
    redirectPath: '/Devicelist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: AddMacID,
    permissions: ['device.read', 'device.all'],
    params: {},
  },
  PLANTTECHNICALVIEW: {
    path: '/TechnicalView',
    key: 'TechnicalView',
    name: 'PlantTechnicalView',
    exact: true,
    redirectPath: '/TechnicalView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: true,
    Component: PlantTechnicalView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['plant.read', 'plant.all'],
    params: {},
  },
  BUSINESSVIEW: {
    path: '/BusinessView',
    key: 'BusinessView',
    name: 'PlantBusinessView',
    exact: true,
    redirectPath: '/BusinessView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: BusinessView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['plant.read', 'plant.all'],
    params: {},
  },
  PLANTMAPVIEW: {
    path: '/PlantMapView',
    key: 'PlantMapView',
    name: 'PlantMapView',
    exact: true,
    redirectPath: '/PlantMapView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: true,
    Component: PlantMapView,
    permissions: ['plant.read', 'plant.all'],
    params: {},
  },
  SOLARMAPVIEW: {
    path: '/SolarMapView',
    key: 'SolarMapView',
    name: 'SolarMapView',
    exact: true,
    redirectPath: '/SolarMapView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: SolarMapView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  LOGREPORT: {
    path: '/LogReport',
    key: 'LogReport',
    name: 'LogReport',
    exact: true,
    redirectPath: '/LogReport',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: LogReport,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['system_log.all'],
    params: {},
  },
  USERLIST: {
    path: '/userlist',
    key: 'Userlist',
    name: 'Userlist',
    exact: true,
    redirectPath: '/userlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: UserList,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['user.all'],
    params: {},
  },
  INTERNALUSERLIST: {
    path: '/internaluserlist',
    key: 'Internaluserlist',
    name: 'Internaluserlist',
    exact: true,
    redirectPath: '/internaluserlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: InternalUserList,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['user.all'],
    params: {},
  },
  MONTHLYGENERATION: {
    path: '/monthlygeneration',
    key: 'Monthlygeneration',
    name: 'Monthlygeneration',
    exact: true,
    redirectPath: '/monthlygeneration',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: MonthlyGeneration,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['analytics.all'],
    params: {},
  },
  INVOICEBILL: {
    path: '/invoice',
    key: 'Invoice',
    name: 'Invoice',
    exact: true,
    redirectPath: '/invoice',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: InvoiceBillDownload,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['invoice.all'],
    params: {},
  },
  PLANTREPORT: {
    path: '/plantreport',
    key: 'Plantreport',
    name: 'Plantreport',
    exact: true,
    redirectPath: '/plantreport',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: PlantReport,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['analytics.all'],
    params: {},
  },
  NOTIFICATIONVIEW: {
    path: '/NotificationView',
    key: 'NotificationView',
    name: 'NotificationView',
    exact: true,
    redirectPath: '/NotificationView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: NotificationView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    permissions: ['notification.all'],
    params: {},
  },
}
